module.exports = __webpack_public_path__ + "static/media/GA_Post_2018.12.08-5.d4e11f15.webp";